/* eslint-disable no-magic-numbers */
import { PickerDateTimeFormat, Quarters } from "./types";
import { language } from "language/default";
const MINIMUM_YEAR = 1980;
export const yearsRange = () => {
    const currentYear = new Date().getFullYear();
    const difference = currentYear - MINIMUM_YEAR + 1;
    return difference;
};
export const MINIMUM_YEAR_RANGE = yearsRange();
export const QUARTERS = {
    [Quarters.Q1]: {
        end: (year) => new Date(year, 2, 31, 23, 59),
        label: language.en.quarterPicker.q1,
        name: Quarters.Q1,
        start: (year) => new Date(year, 0, 1)
    },
    [Quarters.Q2]: {
        end: (year) => new Date(year, 5, 30, 23, 59),
        label: language.en.quarterPicker.q2,
        name: Quarters.Q2,
        start: (year) => new Date(year, 3, 1)
    },
    [Quarters.Q3]: {
        end: (year) => new Date(year, 8, 30, 23, 59),
        label: language.en.quarterPicker.q3,
        name: Quarters.Q3,
        start: (year) => new Date(year, 6, 1)
    },
    [Quarters.Q4]: {
        end: (year) => new Date(year, 11, 31, 23, 59),
        label: language.en.quarterPicker.q4,
        name: Quarters.Q4,
        start: (year) => new Date(year, 9, 1)
    }
};
export const getDateQuarter = (date) => {
    const year = date.getFullYear();
    for (const quarter of Object.values(QUARTERS)) {
        if (date >= quarter.start(year) && date <= quarter.end(year)) {
            return quarter.name;
        }
    }
    return Quarters.Q1;
};
export const getQuarterDateString = (date) => {
    const year = date.getFullYear();
    const quarter = getDateQuarter(date);
    return `${quarter} / ${year} `;
};
export const getQuarterDateStringQuarter = (quarterDate) => {
    const quarterPart = quarterDate.slice(0, 2);
    const quarter = Object.fromEntries(Object.entries(Quarters))[quarterPart];
    return quarter;
};
export const getQuarterDateStringYear = (quarterDate) => {
    const yearPart = quarterDate.slice(5, -1);
    const year = Number(yearPart);
    return year;
};
export const getQuarterDateStringDate = (quarterDate, _start = false) => {
    const quarter = getQuarterDateStringQuarter(quarterDate);
    const year = getQuarterDateStringYear(quarterDate);
    let date = QUARTERS[quarter].start(year);
    if (!_start) {
        date = QUARTERS[quarter].end(year);
    }
    return date;
};
export const getStoreDatePickerDateString = (date) => {
    let day = date.getDate().toString();
    if (day.length < 2) {
        day = `0${day}`;
    }
    let month = (date.getMonth() + 1).toString();
    if (month.length < 2) {
        month = `0${month}`;
    }
    const year = date.getFullYear().toString();
    return `${month}/${day}/${year} `;
};
export const formatDateString = (value, formatSettings, regionCode) => {
    switch (formatSettings) {
        case PickerDateTimeFormat.Localized:
            return new Intl.DateTimeFormat(regionCode, { day: "numeric", month: "short", timeZone: "UTC", year: "numeric" }).format(value);
        case PickerDateTimeFormat.ShortLocalized:
        default:
            return new Intl.DateTimeFormat(regionCode, { timeZone: "UTC" }).format(value);
    }
};
export const getDatePickerDateString = (date, dateFormat, regionCode) => {
    const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    localDate.setMinutes(-localDate.getTimezoneOffset());
    const result = formatDateString(localDate, dateFormat, regionCode);
    return `${result} \u3000`;
};
export const getDatePickerMinYear = () => new Date().getFullYear() - MINIMUM_YEAR_RANGE;
export const getDatePickerQuartersRange = () => Object.values(QUARTERS).map((quarter) => ({
    eventData: quarter.name,
    isSelected: false,
    label: quarter.label
}));
export const getDatePickerYearsRange = () => {
    const result = [];
    for (let i = 0; i < MINIMUM_YEAR_RANGE; i += 1) {
        const iYear = new Date().getFullYear() - i;
        result.push({
            eventData: iYear,
            isSelected: false,
            label: iYear.toString()
        });
    }
    return result;
};
